export const LOADING_ON = 'LOADING_ON'
export const CHAT_LIST_DATA_LOAD = 'CHAT_LIST_DATA_LOAD'
export const CHATROOM_DATA_LOAD = 'CHATROOM_DATA_LOAD'
export const SELECT_CHAT = 'SELECT_CHAT'
export const ADD_NEW_MESSAGE = 'ADD_NEW_MESSAGE'
